import portfolioData from './portfolio.json'

export const projects = portfolioData.projects || []
export const experience = portfolioData.experience || []
export const achievements = portfolioData.achievements || []
export const research = portfolioData.research || []
